const ACTIVE_BUTTON_CLASS = 'b-nav__link_state_active';

class SwitchLanguage {
    constructor($switchButton) {
        this.$switchButton = $switchButton;
        this.$switchList = this.$switchButton.next('.j-switch-list');
    }

    init() {
        this._bindEvents();
    }

    _bindEvents() {
        this.$switchButton.on('click', this._onClickSwitchButton.bind(this));
    }

    _onClickSwitchButton(event) {
        event.preventDefault();
        this.$switchList.fadeToggle();
        this.$switchButton.toggleClass(ACTIVE_BUTTON_CLASS);
    }
}

export default SwitchLanguage;
